import { render, staticRenderFns } from "./noo.vue?vue&type=template&id=454d5df6&scoped=true"
import script from "./noo.vue?vue&type=script&lang=js"
export * from "./noo.vue?vue&type=script&lang=js"
import style0 from "./noo.vue?vue&type=style&index=0&id=454d5df6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454d5df6",
  null
  
)

export default component.exports